import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import DashboardLayout from "./components/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Transactions from "./pages/Transactions";
import Credits from "./pages/Credits";
import Projects from "./pages/Projects";
import Assets from "./pages/Assets";
import APIKeys from "./pages/APIKeys";
import AIProviders from "./pages/AIProviders";
import AICredentials from "./pages/AICredentials";
import AIModels from "./pages/AIModels";
import Capabilities from "./pages/Capabilities";
import RoutingRules from "./pages/RoutingRules";
import PricingRules from "./pages/PricingRules";
import SystemControls from "./pages/SystemControls";
import UsageAnalytics from "./pages/UsageAnalytics";
import ExternalApps from "./pages/ExternalApps";
import Documentation from "./pages/Documentation";
import Tutorials from "./pages/Tutorials";
import ExampleProjectsShowcase from "./pages/ExampleProjectsShowcase";
import ActorAssets from "./pages/ActorAssets";
import LandingPageAssets from "./pages/LandingPageAssets";
import { Toaster } from "./components/ui/sonner";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to="/" replace />
              ) : (
                <LoginPage setIsAuthenticated={setIsAuthenticated} />
              )
            }
          />
          <Route
            path="/"
            element={
              isAuthenticated ? (
                <DashboardLayout setIsAuthenticated={setIsAuthenticated} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="credits" element={<Credits />} />
            <Route path="projects" element={<Projects />} />
            <Route path="assets" element={<Assets />} />
            <Route path="api-keys" element={<APIKeys />} />
            <Route path="ai-providers" element={<AIProviders />} />
            <Route path="ai-credentials" element={<AICredentials />} />
            <Route path="ai-models" element={<AIModels />} />
            <Route path="capabilities" element={<Capabilities />} />
            <Route path="routing-rules" element={<RoutingRules />} />
            <Route path="pricing-rules" element={<PricingRules />} />
            <Route path="system-controls" element={<SystemControls />} />
            <Route path="usage-analytics" element={<UsageAnalytics />} />
            <Route path="external-apps" element={<ExternalApps />} />
            <Route path="tutorials" element={<Tutorials />} />
            <Route path="example-projects" element={<ExampleProjectsShowcase />} />
            <Route path="actor-assets" element={<ActorAssets />} />
            <Route path="landing-assets" element={<LandingPageAssets />} />
            <Route path="documentation" element={<Documentation />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
